export default __webpack_public_path__ + "static/media/button-play.8dc1e7c8.png";